import { useQuery } from '@tanstack/react-query'

import { VirtualCardAPI } from '@apis'


type GroupStatus = typeof VirtualCardAPI.GetUserGroupsRequest.statuses[number]

export function useHasHistoricalGroups(userId: string | undefined | null, enabled: boolean, statuses?: GroupStatus[]) {
    const { data = false, ...query } = useQuery({
        queryKey: ['user-groups-history', userId, statuses?.join(',') || 'default'],
        queryFn: async () => {
            const statusesToCheck = statuses && statuses.length > 0
                ? statuses
                : VirtualCardAPI.GetUserGroupsRequest.statuses.filter((status) => status !== 'active')
            const groupsByStatus = await Promise.all(
                statusesToCheck.map((status) => VirtualCardAPI.GetUserGroupsRequest.fetch(userId!, { page: 1, size: 1, status }))
            )

            return groupsByStatus.some((groups) => groups.length > 0)
        },
        enabled: enabled && !!userId,
        staleTime: 600000,
    })

    return {
        ...query,
        hasHistoricalGroups: data,
    }
}
